import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure, Radio, RadioGroup, Checkbox, Heading, Icon, IconButton, Input, InputGroup, InputRightAddon, Select, SimpleGrid, Stack, StackDivider, Table, TableContainer, Tbody, Td, Text, Textarea, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaArrowRight, FaFileInvoice, FaHistory, FaInfo, FaPlus, FaRandom, FaSave, FaSearch, FaTrash, FaCheck, FaRedo } from "react-icons/fa";
import { TbFileInvoice } from "react-icons/tb";
import APIDropdown from "../../../components/Select/APIDropdown";
import APIDropdownCustom from "../../../components/Select/APIDropdownCustom";
import { useParams } from 'react-router';
import NotFound from "../../404";
import { GET, GETFile, POST, PUT, DELETE  } from "../../../utils/ApiRequestProvider";
import DocViewer, { DocViewerRef, DocViewerRenderers } from "@cyntler/react-doc-viewer";
import './style.css';
import Cookies from "js-cookie";
import getCurrentDate from "../../../utils/utilites";
import { RiContactsBookFill } from "react-icons/ri";
import { useSelector } from "react-redux";

type IMainState = any;

interface Document {
    documentId: number;
    contact: {
        id: number;
        name: string;
        defaultCategory: string;
        defaultPaymentMethod: string;
        defaultVATGSTRate: string;
        business: null | string;
        status: string;
    };
    documentType: string;
    invoiceDate: null | any;
    dueDate: null | any;
    invoiceNumber: string;
    categoryId: null | any;
    vatGstRateId: null | any;
    paymentMethodId: null | any;
    grossAmount: null | any;
    vatMissing: boolean;
    vatAmount: null | any;
    netAmount: null | any;
    exchangeRate: null | any;
    transactionMissing: boolean;
    convertedGrossAmount: null | any;
    convertedVATAmount: null | any;
    convertedNetAmount: null | any;
    descriptionMissing: boolean;
    description: null | any;
    processingNotes: null | any;
    multipleDocuments: null | any;
    isDeleted: boolean;
    status: string;
    transactionCurrencyId: null | any;
    user: {
        userId: number;
        fullName: string;
        email: string;
        role: string;
    };
    category: {
        id: number;
        code: string;
        category: string;
        status: string;
        type: string;
    };
    vatgstRate: {
        id: number;
        name: string;
        percentage: number;
        status: string;
    };
    paymentMethod: {
        id: number;
        bankName: string;
        email: string;
        paymentType: string;
        status: string;
    };
    transactionCurrency:{
        id: number;
        currencyName: string;
        currencyCode: string;
    };
    source: string;
    createdAt: string;
    dataEntryTime: null | any;
    dataEntryOperatorId: number;
    reviewBy: number;
    reviewTime: null | any;
    approvedBySupervisor: number;
    file: string;
    internalDocumentType: string;
}

type urlParams = {
    id: string;
}

interface PaginationType {
    currentPage: number;
    totalPages: number;
    totalRecords: number;
}

interface FileViewerType {
    documentId: number;
    uri: string;
    fileName: string;
}

interface CompanyInfo {
    Name: string;
    Industry: string;
    Country: string;
    Credit: string;
    Software: string;
    Duplicate: string;
    VAT: string;
    VATScheme: string;
    SubscriptionStatus: string;
    SubscriptionPlan: string;
    ProcessingStatus: string;
    DataEntryBy: number;
    DataEntryTime: string;
    ReviewBy: number;
    ReviewTime: string;
    Source: string;
    baseCurrency: string;
}

interface DocumentFormData {
    supplierId: number;
    invoiceDate: string;
    dueDate: string;
    invoiceNumber: string;
    categoryId: number;
    vatGstRateId: number;
    vatGstRateValue: number;
    paymentMethodId: number;
    transactionMissing: boolean;
    grossAmount: string;
    vatMissing: boolean;
    vatAmount: string;
    netAmount: number;
    transactionCurrencyId: number;
    baseCurrency: string;
    exchangeRate: number;
    convertedGrossAmount: number;
    convertedVATAmount: number;
    convertedNetAmount: number;
    descriptionMissing: boolean;
    description: string;
    additionalOptions: string;
    dataEntryOperatorId: number;
}

const initialCompanyInfo: CompanyInfo = {
    Name: '',
    Industry: '',
    Country: '',
    Credit: '',
    Software: '',
    Duplicate: '',
    VAT: '',
    VATScheme: '',
    SubscriptionStatus: '',
    SubscriptionPlan: '',
    ProcessingStatus: '',
    DataEntryBy: 0,
    DataEntryTime: '',
    ReviewBy: 0,
    ReviewTime: '',
    Source: '',
    baseCurrency: '',
}

const initialFormData: DocumentFormData = {
    supplierId: 0,
    invoiceDate: '',
    dueDate: '',
    invoiceNumber: '',
    categoryId: 0,
    vatGstRateId: 0,
    vatGstRateValue: 0,
    paymentMethodId: 0,
    transactionMissing: false,
    grossAmount: '0.00',
    vatMissing: false,
    vatAmount: '0.00',
    netAmount: 0.00,
    transactionCurrencyId: 0,
    baseCurrency: '',
    exchangeRate: 0.00,
    convertedGrossAmount: 0.00,
    convertedVATAmount: 0.00,
    convertedNetAmount: 0.00,
    descriptionMissing: false,
    description: '',
    additionalOptions: '',
    dataEntryOperatorId: 0,
}

export default function SalesDocuments() {
    const { id } = useParams<urlParams>();
    const toast = useToast();
    let user = JSON.parse(localStorage.getItem("user") ?? (Cookies.get("user") ?? "{}"));
    let role = user.role;

    const [loading, setLoading] = useState(false);
    const [paginationQuery] = useState({ page: 1, pageSize: 10 });
    const [companyInfo, setCompanyInfo] = useState<CompanyInfo>(initialCompanyInfo);
    const [, setPagination] = useState<PaginationType>({ currentPage: 0, totalPages: 0, totalRecords: 0 });
    const [documents, setDocuments] = useState<Document[]>([]);
    const [selectedDocument, setSelectedDocument] = useState<FileViewerType[]>([]);
    const docViewerRef = useRef<DocViewerRef>(null);
    const [selectedDocumentId, setSelectedDocumentId] = useState<number>(0);
    const [formData, setFormData] = useState<DocumentFormData>(initialFormData);
        const [suppliers] = useState("");
    const business = useSelector((state: any) => state.selections.value?.business);
        const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isOpenHistory, onOpen: onOpenHistory, onClose: onCloseHistory } = useDisclosure();
    const { isOpen: isOpenReason, onOpen: onOpenReason, onClose: onCloseReason } = useDisclosure();
    const { isOpen: isOpenSuppHistory, onOpen: onOpenSuppHistory, onClose: onCloseSuppHistory } = useDisclosure();
    const { isOpen: isOpenReclassify, onClose: onCloseReclassify } = useDisclosure();
    const [reason, setReason] = useState('');
    const [History, setHistory] = useState([]);
    const [SuppHistory, setSuppHistory] = useState([]);
    const [form, setForm] = useState<any>({
        name: '',
        chartOfAccountId: 0,
        paymentMethodId: 0,
        vatgstRateId: 0,
        status: '',
        isSupplier: false
    });
    const [, setItems] = useState<Array<any>>([]);
    const [Doc, setDoc] = useState('PurchaseInvoice');

    const handleInputChange = (
        eventOrValue: ChangeEvent<any> | string,
        fieldName?: string
    ) => {
        // debugger;
                // debugger;
        // console.log(eventOrValue);
        if(fieldName === 'supplierId'){
            // console.log(typeof eventOrValue === 'object' ? eventOrValue.target?.value : eventOrValue)
            if((typeof eventOrValue === 'object' ? eventOrValue.target?.value : eventOrValue) === 'Add Customer'){
                isOpen ? onClose() : onOpen();
            }
        }
        // calculate(val,fieldName);
        setFormData((prevFormData) => {
            if (!prevFormData) {
                return prevFormData;
            }
            const name = fieldName ? fieldName : (typeof eventOrValue === 'object' ? eventOrValue.target?.name : fieldName);
            const value = typeof eventOrValue === 'object' ? eventOrValue.target?.value : eventOrValue;
            if (!name) {
                return prevFormData;
            }
            return {
                ...prevFormData,
                [name]: value,
            };
        });
    };

    const handleTD = () => {
        let currentDate= getCurrentDate('-');
        const updatedFormData = { ...formData };
        updatedFormData.invoiceDate = currentDate;
        updatedFormData.dueDate = currentDate;
        setFormData(updatedFormData);
    }

    const handleReason = (e: any) => {
        setReason(e.target.value);
    }

    const VATMissing = () => {
        const updatedFormData = { ...formData };
        if(updatedFormData.vatMissing){
            updatedFormData.vatMissing = false;
        }
        else{
            updatedFormData.vatGstRateId = 0;
            updatedFormData.vatGstRateValue = 0;
            updatedFormData.vatAmount = '0';
            updatedFormData.convertedVATAmount = 0;
            updatedFormData.vatMissing = true;
        }
        setFormData(updatedFormData);
    }

    const TransactionZero = () => {
        const updatedFormData = { ...formData };
        updatedFormData.grossAmount = '0';
        updatedFormData.netAmount = 0;
        updatedFormData.vatAmount = '0';
        updatedFormData.convertedNetAmount = 0;
        updatedFormData.convertedVATAmount = 0;
        updatedFormData.convertedGrossAmount = 0;
        setFormData(updatedFormData);
    }

    const TransactionMissing = () => {
        const updatedFormData = { ...formData };
        if(updatedFormData.transactionMissing){
            updatedFormData.transactionMissing = false;
        }else{
            updatedFormData.grossAmount = '0';
            updatedFormData.netAmount = 0;
            updatedFormData.vatAmount = '0';
            updatedFormData.convertedNetAmount = 0;
            updatedFormData.convertedVATAmount = 0;
            updatedFormData.convertedGrossAmount = 0;
            updatedFormData.transactionMissing = true;
        }
        
        setFormData(updatedFormData);
    }

    const DescriptionMissing = () => {
        const updatedFormData = { ...formData };
        if(updatedFormData.descriptionMissing){
            updatedFormData.descriptionMissing = false;
        }else{
            updatedFormData.description = '';
            updatedFormData.descriptionMissing = true;
        }
        
        setFormData(updatedFormData);
    }

    const vatGstRateChange = (e: any) => {
        if(e !== undefined){
            calculate(e.percentage,'vatGstRateId',e.id);
        }else{
            calculate('0.00','vatGstRateId',0);
        }
        // setFormData(prev => ({ ...prev, vatGstRateId: e.id, vatGstRateValue: e.percentage }));
    }

    const calculate = async (val: string,field?: string,id: number = 0) => {
        const updatedFormData = { ...formData };
        let gstRate = 0;

        if(field === 'vatGstRateId'){
            gstRate = parseFloat((parseFloat(val) / 100).toFixed(2));
            updatedFormData.vatGstRateValue = parseFloat(val);
            updatedFormData.vatGstRateId = id;
        }else{
            gstRate = parseFloat((updatedFormData.vatGstRateValue / 100).toFixed(2)) ;
        }
        // debugger;
        if(field === 'grossAmount'){
            updatedFormData.grossAmount = val;
        }
        if(field === 'exchangeRate'){
            updatedFormData.exchangeRate = parseFloat(val);
        }
        let netAmount = parseFloat((parseFloat(updatedFormData.grossAmount) / (1 + gstRate)).toFixed(2));
        let vatAmount = parseFloat((netAmount * gstRate).toFixed(2));
        // updatedFormData.grossAmount = formData.grossAmount;
        updatedFormData.vatAmount = (vatAmount).toString();
        updatedFormData.netAmount = netAmount;
        updatedFormData.convertedGrossAmount = parseFloat((parseFloat(updatedFormData.grossAmount) * updatedFormData.exchangeRate).toFixed(2));
        updatedFormData.convertedNetAmount = parseFloat((netAmount * updatedFormData.exchangeRate).toFixed(2));
        updatedFormData.convertedVATAmount = parseFloat((updatedFormData.exchangeRate * vatAmount).toFixed(2));
        setFormData(updatedFormData);
        // console.log(updatedFormData);
    };

    async function GetHistory(){
                // console.log(SelectedId);
        if(selectedDocumentId === 0){
            toast({
                title: 'Error!',
                description: 'Please select a document to view history',
                status: 'error',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });
            // alert('Please select a document to view history');
            return;
        }
        const response = await GET(`api/Documents/getDocumentHistory?doc=${selectedDocumentId}`);
        // console.log(response);
        if(response.status === 'success'){
            if(response.data.length > 0){
                setHistory(response.data)
                onOpenHistory();
            }else{
                toast({
                    title: 'Error!',
                    description: 'No history found for this document',
                    status: 'error',
                    isClosable: true,
                    duration: 1000,
                    position: 'top-right'
                });
            }
            
            
        }
        
    }
    
    const handleBaseCurrencyChange = async (e: any) => {
        const transactionCurrency = e.currencyCode;
        const BaseCurrency = formData.baseCurrency;
        const response = await GET(`https://api.freecurrencyapi.com/v1/latest?apikey=fca_live_FSQ5KPY2ukwYeHDJ4YUItGho4OKosDa38YUp94bR&currencies=${transactionCurrency}&base_currency=${BaseCurrency}`);
        if(response.data !== null && response.data !== undefined){
            const exchangeRate = response.data[transactionCurrency];
            const updatedFormData = { ...formData };
            updatedFormData.transactionCurrencyId = e.id;
            updatedFormData.exchangeRate = parseFloat(exchangeRate.toFixed(4));
            updatedFormData.convertedGrossAmount = parseFloat((parseFloat(formData.grossAmount) * exchangeRate).toFixed(2));
            updatedFormData.convertedVATAmount = parseFloat((parseFloat(formData.vatAmount) * exchangeRate).toFixed(2));
            updatedFormData.convertedNetAmount = parseFloat(((formData.netAmount) * exchangeRate).toFixed(2));
            setFormData(updatedFormData);
        }
        else{
            toast({
                title: 'Error!',
                description: 'Could not fetch exchange rate for the selected currency.',
                status: 'error',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    async function ViewDocument(item: Document,check: any) {

        setLoading(true);
        // console.log(item)
        try {
            const { status: ProcessingStatus, source: Source, dataEntryOperatorId: DataEntryBy, dataEntryTime: DataEntryTime, reviewBy:ReviewBy, reviewTime: ReviewTime } = item;
            setCompanyInfo(prev => ({ ...prev, ProcessingStatus, Source, DataEntryBy, DataEntryTime,ReviewBy,ReviewTime }));
            if (selectedDocument.find(x => x.documentId === item.documentId)) {
                setSelectedDocument(selectedDocument.filter(x => x.documentId !== item.documentId));
                if(check === false){
                    setFormData(initialFormData);
                    // setSelectedDocument(
                    //     selectedDocument.filter(x => x.documentId !== item.documentId)
                    // );
                    setSelectedDocumentId(selectedDocument.length > 0 ? selectedDocument[selectedDocument.length - 1].documentId : 0);
                    return;
                }
            }
            

            toast({
                title: 'Loading Document!',
                description: 'Document is being loaded, please wait a moment!',
                status: 'info',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });

            const file = await GETFile(item.file);
            setSelectedDocument([...selectedDocument, {
                documentId: item.documentId,
                uri: URL.createObjectURL(file),
                fileName: file.name,
            }]);

            setSelectedDocumentId(item.documentId);
            if(item.category === null){
                item.category = { 'id': 0, 'code': '', 'category': '', 'status': '', 'type': ''};
            }

            if(item.vatgstRate === null){
                item.vatgstRate = { 'id': 0, 'name': '', 'percentage': 0, 'status': ''};
            }
            
            if(item.paymentMethod === null){
                item.paymentMethod = { 'id': 0, 'bankName': '', 'email': '', 'paymentType': '', 'status': ''};
            }
            
            if(item.transactionCurrency === null){
                item.transactionCurrency = { 'id': 0, 'currencyName': '', 'currencyCode': ''};
            }

            if(item.contact === null){
                item.contact = { 'id': 0, 'name': '', 'defaultCategory': ''
                , 'defaultPaymentMethod': '', 'defaultVATGSTRate': '', 'business': ''
                , 'status': ''};
            }

            const formDataNew:DocumentFormData = {
                supplierId: item.contact.id,
                invoiceDate: item.invoiceDate,
                dueDate: item.dueDate,
                invoiceNumber: item.invoiceNumber,
                categoryId: item.category.id,
                vatGstRateId: item.vatgstRate.id,
                vatGstRateValue: item.vatgstRate.percentage,
                paymentMethodId: item.paymentMethod.id,
                transactionMissing: item.transactionMissing,
                grossAmount: item.grossAmount,
                vatMissing: item.vatMissing,
                vatAmount: item.vatAmount,
                netAmount: item.netAmount,
                transactionCurrencyId: item.transactionCurrency.id,
                baseCurrency: companyInfo.baseCurrency,
                exchangeRate: item.exchangeRate,
                convertedGrossAmount: item.convertedGrossAmount,
                convertedVATAmount: item.convertedVATAmount,
                convertedNetAmount: item.convertedNetAmount,
                descriptionMissing: item.descriptionMissing,
                description: item.description,
                additionalOptions: item.processingNotes,
                dataEntryOperatorId: item.dataEntryOperatorId,
            };
            
            setFormData(formDataNew);
        } catch (err) {
            // console.log(err);
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occurred while proceeding your request!',
                status: 'error',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });
        }
        setLoading(false);
    }

    const prevDocument = async () => {
        const index = documents.findIndex(doc => doc.documentId === selectedDocumentId);
        if (index > 0) {
            const prevDocument = documents[index - 1];
            await ViewDocument(prevDocument,false);
            setSelectedDocumentId(prevDocument.documentId);
        }
    }

    const nextDocument = async () => {
        const index = documents.findIndex(doc => doc.documentId === selectedDocumentId);
        if (index < documents.length - 1) {
            const nextDocument = documents[index + 1];
            await ViewDocument(nextDocument,false);
            setSelectedDocumentId(nextDocument.documentId);
        }
    }

    function DocumentHeader(state: IMainState, previousDocument: () => void, nextDocument: () => void) {
        useEffect(() => {
            setSelectedDocumentId((state?.currentDocument as any)?.documentId);
        }, [state?.currentDocument]);
        return null;
    }

    async function runGetRequest(handleData: (data: any) => void, url: string) {
        setLoading(true);
        try {
            const res = await GET(url);
            if (res.status === 'success' && (
                (Array.isArray(res.data) && res.data.length > 0)
                || (Object.keys(res.data) && Object.keys(res.data).length > 0))
            ) {
                const { data } = res;
                handleData(data);
            }
        } catch (err) {
            // console.log(err)
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occurred while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
        setLoading(false);
    }

    async function getDocuments() {
        const stat = role === "supervisor" ? "&status=Review" : "&status=Uploaded";
        // console.log(role);
        runGetRequest((data: any) => {
            const { docs: [{ documents, ...companyInfo }], pagination } = data;
            setPagination(pagination);
            setDocuments(documents);
            setCompanyInfo(companyInfo);
        }, `/api/Documents/${id}/SalesInvoice/InvoiceList?page=${paginationQuery.page}&pageSize=${paginationQuery.pageSize}${stat}&sortColumn=Date&sortOrder=desc`);
        
    }

    async function saveDocument(forsave: string) {
        setLoading(true);
        try {
            const data = {
                ...formData,
                baseCurrency: companyInfo.baseCurrency,
                dataEntryOperatorId: 1,
                isSave: forsave === "save" ? true : false,
            }
            const stat = role === "supervisor" ? "processed" : "save";
            
            const res = await PUT(`/api/Documents/${stat}/${selectedDocumentId}`, data);
            if (res.status === 'success') {
                const type = forsave === "save" ? 'Saved' : 'Processed';
                toast({
                    title: `Document ${type} Successfully!`,
                    description: `Document has been ${type} successfully!`,
                    status: 'success',
                    isClosable: true,
                    duration: 1000,
                    position: 'top-right'
                });
                if(forsave !== "save"){
                    setFormData(initialFormData);
                    getDocuments();
                }
                
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occurred while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
        setLoading(false);
    }

    async function Save() {
        try {
            setLoading(true);

            const response = await POST(
                '/api/contacts',
                {
                    ...form,
                    businessId: id
                }
            );
            
            setLoading(false);
            if (response.status === 'success') {
                toast({
                    status: response.status,
                    title: response.message,
                    isClosable: false,
                    duration: 1000,
                    position: 'top-right'
                });
                FetchList();
                setForm({
                    name: '',
                    chartOfAccountId: 0,
                    paymentMethodId: 0,
                    vatgstRateId: 0,
                    status: '',
                    isSupplier: false
                });
                onClose();
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            }

        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    useEffect(() => {
        FetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [business]);

    async function FetchList() {
        try {
            if (id) {
                const res = await GET(`/api/contacts/${id}`);
                setItems(res.data);
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    const handleDelete = async () => {
        if(selectedDocumentId === 0){
            toast({
                title: 'Error!',
                description: 'Please select a document to delete!',
                status: 'error',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        onOpenReason();
    }

    const handleRedo = async () => {
        if(selectedDocumentId === 0){
            toast({
                title: 'Error!',
                description: 'Please select a document to redo!',
                status: 'error',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        const response = await PUT(`api/Documents/reAssign/${selectedDocumentId}?status=Uploaded`, {});
        if(response.status === 'success'){
            toast({
                title: 'Document Redo Successfully!',
                description: 'Document has been redone successfully!',
                status: 'success',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });
            getDocuments();
        }
    }

    const handleReasonDelete = async () => {
        if(reason === ''){
            toast({
                title: 'Error!',
                description: 'Please provide a reason for delete!',
                status: 'error',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        try {
            setLoading(true);
            var arr: any[] = [];
            selectedDocument.forEach((item) => {
                arr.push(item.documentId);
            });
            var arr_to_delete = {'documents_ids': arr, 'reason': reason}
            // console.log(arr_to_delete)
            const response = await DELETE(`/api/Documents/deleteDocuments`, arr_to_delete);
            if (response.status === 'success') {
                toast({
                    title: 'Document Deleted Successfully!',
                    description: 'Document has been deleted successfully!',
                    status: 'success',
                    isClosable: true,
                    duration: 1000,
                    position: 'top-right'
                });
                setFormData(initialFormData);
                getDocuments();
                onCloseReason();
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occurred while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    const convertDate = (date: string) => {
        const datehistory = new Date(date).toUTCString()
        return datehistory;
    }

    const handleSuppHistory = async () => {
        if(formData.supplierId === 0){
            toast({
                title: 'Error!',
                description: 'Please select a Customer to view history',
                status: 'error',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }

        const response = await GET(`api/Documents/getDocumnetsByContact?contactId=${formData.supplierId}`);
        // console.log(response);
        if(response.status === 'success'){
            if(response.data.length > 0){
                setSuppHistory(response.data)
                onOpenSuppHistory();
            }else{
                toast({
                    title: 'Error!',
                    description: 'No history found for this Customer',
                    status: 'error',
                    isClosable: true,
                    duration: 1000,
                    position: 'top-right'
                });
            }
        }
    }

    
    const handleReClassify = async () => {
        if(selectedDocument.length === 0 || selectedDocument.length === undefined){
            toast({
                title: 'No Document Selected!',
                description: 'Please select a document to reclassify!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
            
        if(window.confirm('Are you sure to Reclassify this document?')){
            var arr_ids : any[] = [];
            selectedDocument.forEach((item) =>{
                arr_ids.push(item.documentId);
            });
            var arr_to_reclassify = {"documents_Id": arr_ids, "doctype": Doc};
            const response = await PUT(`/api/documents/reclassify`, arr_to_reclassify);
            if(response.status === "success"){
                toast({
                    title: 'Document Reclassified!',
                    description: 'Document has been reclassified successfully!',
                    status: 'success',
                    isClosable: false,
                    duration: 1000,
                    position: 'top-right'
                });
                getDocuments();
            }
        }
    }

    useEffect(() => {
        console.log(formData);
        
    }, [formData]);

    useEffect(()=>{
    },[suppliers])

    useEffect(() => {
        getDocuments();
        // console.log(companyInfo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!id) { return <NotFound /> };

    return (
        
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Modal
                isCentered
                size={'3xl'}
                isOpen={isOpen}
                onClose={onClose}
            >
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px)'
                />
                <ModalContent>
                    <ModalHeader
                        as={Stack}
                        direction={'row'}
                        borderBottom={'2px'}
                        borderBottomColor={'gray.300'}
                    >
                        <Icon
                            as={RiContactsBookFill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Add Customers</Heading>
                            <Text fontSize={'sm'}>Add new Customers from here</Text>
                        </Stack>
                    </ModalHeader>
                    <ModalBody as={Stack} direction={'row'} spacing={4} py={8}>
                        <Stack spacing={4} w={'full'}>
                            <Input
                                w={'full'}
                                type={'text'}
                                size={'md'}
                                placeholder={'Name'}
                                value={form.name}
                                onChange={(e: any) => setForm({ ...form, name: e.target.value })}
                            />
                            <APIDropdown
                                w={'full'}
                                placeholder={'Default Category'}
                                fetchurl={`/api/chartofaccounts/${id}`}
                                itemselect={(item) => setForm({ ...form, chartOfAccountId: item.id })}
                                valuekey={'id'}
                                textkey={'category'}
                            />
                            <APIDropdown
                                w={'full'}
                                placeholder={'Default Payment Method'}
                                fetchurl={`/api/paymentmethods/${id}`}
                                itemselect={(item) => setForm({ ...form, paymentMethodId: item.id })}
                                valuekey={'id'}
                                textkey={'displayName'}
                            />
                        </Stack>
                        <Stack spacing={4} w={'full'}>
                            <APIDropdown
                                w={'full'}
                                placeholder={'Default VAT/GST Rate'}
                                fetchurl={`/api/vatgst/${id}`}
                                itemselect={(item) => setForm({ ...form, vatgstRateId: item.id })}
                                valuekey={'id'}
                                textkey={'name'}
                            />
                            <Select
                                w={'full'}
                                placeholder={'Status'}
                                defaultValue={form.status}
                                onChange={(e: any) =>
                                    setForm({ ...form, status: e.target.value })
                                }
                            >
                                <option defaultValue={'Active'}>Active</option>
                                <option defaultValue={'Inactive'}>Inactive</option>
                            </Select>
                            <Select w={'full'} defaultValue={form.isSupplier === true ? 'Supplier' : 'Customer'} 
                            onChange={(e: any) => setForm({ ...form, isSupplier: e.target.value === 'Supplier' ? true : false })}>
                                <option defaultValue={'Customer'} value={form.isSupplier}>Customer</option>
                            </Select>
                        </Stack>
                    </ModalBody>
                    <ModalFooter
                        as={Stack}
                        direction={'row'}
                        spacing={4}
                        borderTop={'2px'}
                        borderTopColor={'gray.300'}
                    >
                        <Button
                            w={'full'}
                            onClick={onClose}
                        >
                            Close
                        </Button>
                        <Button
                            w={'full'}
                            onClick={Save}
                            leftIcon={<FaCheck />}
                            colorScheme={'primary'}
                            isLoading={loading}
                        >
                            Save
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Modal
                isCentered
                size={'6xl'}
                isOpen={isOpenHistory}
                onClose={onCloseHistory}
            >
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px)'
                />
                <ModalContent>
                    <ModalHeader
                        as={Stack}
                        direction={'row'}
                        borderBottom={'2px'}
                        borderBottomColor={'gray.300'}
                    >
                        <Icon
                            as={RiContactsBookFill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>History</Heading>
                        </Stack>
                    </ModalHeader>
                    <ModalBody as={Stack} direction={'row'} spacing={4} py={8}>
                        <Stack w={'full'}>
                            <Table>
                                <Thead>
                                    <Th>Document Id</Th>

                                    <Th>User</Th>
                                    {/* <Th>Document Type</Th> */}
                                    <Th>Document Status</Th>
                                    {/* <Th>Processed By</Th> */}
                                    <Th>Processed Time</Th>
                                    <Th>Email</Th>
                                </Thead>
                                <Tbody>
                                    {
                                        History.length > 0 ? History.map((item: any) => (
                                            <Tr>
                                                <Td>{item.documentId}</Td>
                                                <Td>{item.actionByEmail.split('@')[0]}</Td>
                                                {/* <Td>{item.documentType}</Td> */}
                                                <Td>{item.status}</Td>
                                                {/* <Td>{item.processedBy}</Td> */}
                                                <Td>{convertDate(item.createdAt)}</Td>
                                                <Td>{item.actionByEmail}</Td>
                                            </Tr>
                                        )) : 
                                        <Tr>
                                            <Td colSpan={5}>
                                                <Text w={'full'} textAlign={'center'}>No History Found</Text>
                                            </Td>
                                        </Tr>
                                    }
                                </Tbody>
                            </Table>
                        </Stack>
                    </ModalBody>
                    <ModalFooter
                        as={Stack}
                        direction={'row'}
                        spacing={4}
                        borderTop={'2px'}
                        borderTopColor={'gray.300'}
                    >
                        <Button
                            w={'full'}
                            onClick={onCloseHistory}
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Modal
                isCentered
                size={'8xl'}
                isOpen={isOpenSuppHistory}
                onClose={onCloseSuppHistory}
            >
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px)'
                />
                <ModalContent>
                    <ModalHeader
                        as={Stack}
                        direction={'row'}
                        borderBottom={'2px'}
                        borderBottomColor={'gray.300'}
                    >
                        <Icon
                            as={RiContactsBookFill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Customer History</Heading>
                        </Stack>
                    </ModalHeader>
                    <ModalBody as={Stack} direction={'row'} spacing={4} py={8}>
                        <Stack w={'full'}>
                            <Table>
                                <Thead>
                                    <Th>Document Id</Th>
                                    <Th>Document Type</Th>
                                    <Th>Due Date</Th>
                                    <Th>VAT GST Rate</Th>
                                    <Th>Gross Amount</Th>
                                    <Th>VAT Amount</Th>
                                    <Th>Net Amount</Th>
                                    <Th>Payment Method</Th>
                                </Thead>
                                <Tbody>
                                    {
                                        SuppHistory.map((item: any) => (
                                            <Tr>
                                                <Td>{item.id}</Td>
                                                <Td>{item.documentType}</Td>
                                                <Td>{convertDate(item.dueDate)}</Td>
                                                <Td>{item.vatgstRate.percentage}%</Td>
                                                <Td>{item.grossAmount}</Td>
                                                <Td>{item.vatAmount}</Td>
                                                <Td>{item.netAmount}</Td>
                                                <Td>{(item.paymentMethod !== null && item.paymentMethod !== undefined) ? item.paymentMethod.displayName : "No Payment Method"}</Td>
                                            </Tr>
                                        ))
                                    }
                                </Tbody>
                            </Table>
                        </Stack>
                    </ModalBody>
                    <ModalFooter
                        as={Stack}
                        direction={'row'}
                        spacing={4}
                        borderTop={'2px'}
                        borderTopColor={'gray.300'}
                    >
                        <Button
                            w={'full'}
                            onClick={onCloseSuppHistory}
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Modal
                isCentered
                size={'4xl'}
                isOpen={isOpenReason}
                onClose={onCloseReason}
            >
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px)'
                />
                <ModalContent>
                    <ModalHeader
                        as={Stack}
                        direction={'row'}
                        borderBottom={'2px'}
                        borderBottomColor={'gray.300'}
                    >
                        <Icon
                            as={RiContactsBookFill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Reason for Delete</Heading>
                        </Stack>
                    </ModalHeader>
                    <ModalBody as={Stack} direction={'row'} spacing={4} py={8}>
                        <Stack w={'full'}>
                            <Textarea placeholder="Reason for Delete" onChange={handleReason} />
                            
                            <Button
                                w={'full'}
                                onClick={handleReasonDelete}
                                leftIcon={<FaTrash />}
                                colorScheme={'primary'}
                                isLoading={loading}
                            >
                                Delete
                            </Button>
                        </Stack>
                    </ModalBody>
                    <ModalFooter
                        as={Stack}
                        direction={'row'}
                        spacing={4}
                        borderTop={'2px'}
                        borderTopColor={'gray.300'}
                    >
                        <Button
                            w={'full'}
                            onClick={onCloseReason}
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            
            <Modal
                isCentered
                size={'4xl'}
                isOpen={isOpenReclassify}
                onClose={onCloseReclassify}
            >
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px)'
                />
                <ModalContent>
                    <ModalHeader
                        as={Stack}
                        direction={'row'}
                        borderBottom={'2px'}
                        borderBottomColor={'gray.300'}
                    >
                        <Icon
                            as={RiContactsBookFill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Document ReClassify</Heading>
                        </Stack>
                    </ModalHeader>
                    <ModalBody as={Stack} direction={'row'} spacing={4} py={8}>
                        <Stack w={'full'}>
                            <RadioGroup size={'sm'} colorScheme={'primary'} onChange={setDoc} defaultValue={Doc}>
                                <Stack direction='row'>
                                    <Radio value='PurchaseInvoice'>Purchase Invoice</Radio>
                                    <Radio value='OtherDocuments'>Other Documents</Radio>
                                    <Radio value='BankStatement'>Bank Statement</Radio>
                                </Stack>
                            </RadioGroup>
                        </Stack>
                        <Stack w={'full'}>
                            <Button
                                w={'full'}
                                onClick={handleReClassify}
                                leftIcon={<FaFileInvoice />}
                                colorScheme={'primary'}
                                isLoading={loading}
                            >
                                Reclassify
                            </Button>
                        </Stack>
                    </ModalBody>
                    <ModalFooter
                        as={Stack}
                        direction={'row'}
                        spacing={4}
                        borderTop={'2px'}
                        borderTopColor={'gray.300'}
                    >
                        <Button
                            w={'full'}
                            onClick={onCloseReclassify}
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'column', "2xl": "row" }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 6, "2xl": 0 }}
            >
                <Stack
                    align={'start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'} justify={'start'} align={'center'}>
                        <Icon
                            as={TbFileInvoice}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Invoices & Receipts</Heading>
                            <SimpleGrid templateColumns={'1fr 1fr 1fr'} columnGap={2}>
                                
                                <Text>Name: <strong>{companyInfo.Name}</strong></Text>
                                <Text>Industry: <strong>{companyInfo.Industry}</strong></Text>
                                <Text>Country: <strong>{companyInfo.Country}</strong></Text>
                                <Text>Credit: <strong>{companyInfo.Credit}</strong></Text>
                                <Text>Software: <strong>{companyInfo.Software}</strong></Text>
                                <Text>Duplicate: <strong>{companyInfo.Duplicate}</strong></Text>
                                <Text>VAT: <strong>{companyInfo.VAT}</strong></Text>
                                <Text>VAT Scheme: <strong>{companyInfo.VATScheme}</strong></Text>
                                <Text>Subscription Status: <strong>{companyInfo.SubscriptionStatus}</strong></Text>
                                <Text>Subscription Plan: <strong>{companyInfo.SubscriptionPlan}</strong></Text>
                                <Text>Processing Status: <strong>{companyInfo.ProcessingStatus}</strong></Text>
                                <Text>Data Entry By: <strong>{companyInfo.DataEntryBy}</strong></Text>
                                <Text>Data Entry Time: <strong>{companyInfo.DataEntryTime!== "" && convertDate(companyInfo.DataEntryTime)}</strong></Text>
                                <Text>Reviewed By: <strong>{companyInfo.ReviewBy}</strong></Text>
                                <Text>Reviewed Time: <strong>{companyInfo.ReviewTime}</strong></Text>
                                <Text>Source: <strong>{companyInfo.Source}</strong></Text>
                            </SimpleGrid>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', "2xl": 'flex-end' }} direction={'row'} spacing={4}>
                    <Button
                        size={'sm'}
                        leftIcon={<FaFileInvoice />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Reclassify
                    </Button>

                    <Button
                        size={'sm'}
                        leftIcon={<FaSearch />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                    >
                        Azure
                    </Button>

                    <Button
                        size={'sm'}
                        leftIcon={<FaHistory />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                        onClick={GetHistory}
                    >
                        History
                    </Button>

                    <IconButton
                        colorScheme={'orange'}
                        aria-label='Prev'
                        rounded={'full'}
                        onClick={prevDocument}
                        icon={<FaArrowLeft />}
                    />

                    <IconButton
                        colorScheme={'orange'}
                        aria-label='Refresh'
                        rounded={'full'}
                        onClick={nextDocument}
                        icon={<FaArrowRight />}
                    />
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <SimpleGrid
                    templateColumns={{ base: '1fr', md: '1fr 3fr 3fr' }}
                    spacing={6}
                >
                    <Stack w={'250px'}>
                        <Button
                            size={'sm'}
                            leftIcon={<FaTrash />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            onClick={handleDelete}
                        >
                            Delete
                        </Button>
                        <TableContainer>
                            <Table size='sm'>
                                <Thead h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                                    <Tr>  
                                        
                                    </Tr>
                                    <Tr>
                                        <Th></Th>
                                        <Th
                                            color={'white'}
                                            isNumeric
                                        >
                                            ID
                                        </Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        documents.map(item => (
                                            <Tr key={item.documentId} backgroundColor={selectedDocumentId === item.documentId ? '#edf2f6' : 'initial'}>
                                                <Td
                                                >
                                                    <Checkbox
                                                        colorScheme='primary'
                                                        onChange={(event) => ViewDocument(item,event.target.checked)}
                                                        
                                                    />
                                                </Td>
                                                <Td
                                                    isNumeric
                                                >
                                                    {item.documentId}
                                                </Td>
                                            </Tr>
                                        ))
                                    }
                                    {/* <Tr>
                                        <Td colSpan={2} textAlign={'center'}>There is no document in this folder</Td>
                                    </Tr> */}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Stack>
                    <Stack>
                        <Stack w={'100%'} maxW={'100%'} h={'full'} maxH={'650px'} align={'center'} justify={'center'} textAlign={'center'} bg={'gray.500'}>
                            {
                                selectedDocument.length > 0 ?
                                    <DocViewer
                                        ref={docViewerRef}
                                        pluginRenderers={DocViewerRenderers}
                                        documents={selectedDocument}
                                        config={{
                                            header: {
                                                overrideComponent: DocumentHeader,
                                            },
                                            csvDelimiter: ",",
                                            pdfZoom: {
                                                defaultZoom: 1.1,
                                                zoomJump: 0.2,
                                            },
                                            pdfVerticalScrollByDefault: true,
                                        }}
                                        style={{ overflowY: 'auto' }}
                                        theme={{
                                            primary: "#ffffffeb",
                                            secondary: "#ffffff",
                                            tertiary: "#05445d",
                                            textPrimary: "#000000",
                                            textSecondary: "#ffffff",
                                            textTertiary: "#ffffff",
                                        }}
                                    />
                                    : <>
                                        <Heading color={'white'}>Document Viewer</Heading>
                                        <Text color={'whiteAlpha.900'} padding={'0 10px'}>No Documents Selected! Select Any Document To Preview Here.</Text>
                                    </>
                            }
                        </Stack>
                    </Stack>
                    <Stack w={'full'} spacing={2} divider={<StackDivider />}>
                        <Stack>
                            <Stack direction={{ md: 'column', lg: 'row' }} align={"flex-end"}>
                                <Stack
                                    w={'full'}
                                    spacing={0.5}
                                >
                                    <Stack
                                        w={'full'}
                                        spacing={1}
                                        direction={'row'}
                                        justify={'flex-end'}
                                    >
                                        <Button
                                            leftIcon={<FaPlus />}
                                            _hover={{ bg: 'primary.400', color: 'white' }}
                                            _active={{ bg: 'primary.700', color: 'white' }}
                                            rounded={'none'}
                                            size={'sm'}
                                            w={'fit-content'}
                                        >
                                            Misc
                                        </Button>

                                        <IconButton
                                            aria-label="Customer History"
                                            _hover={{ bg: 'primary.400', color: 'white' }}
                                            _active={{ bg: 'primary.700', color: 'white' }}
                                            rounded={'none'}
                                            size={'sm'}
                                            icon={<FaHistory />}
                                            onClick={handleSuppHistory}
                                        />
                                    </Stack>
                                    <InputGroup size='sm' flex={1}>
                                        <APIDropdownCustom
                                            fetchurl={`/api/Contacts/${id}?isSupplier=false`}
                                            valuekey={'id'}
                                            textkey={'name'}
                                            size={'sm'}
                                            placeholder="Select Customer"
                                            name="supplierId"
                                            value={formData.supplierId}
                                            itemselect={(e) => handleInputChange(e, 'supplierId')}
                                            addoption={"true"}
                                            addoptionvalue={"Customer"}
                                        />
                                        <InputRightAddon
                                            as={Button}
                                            color={'black'}
                                            colorScheme={'blue'}
                                            children={<FaInfo />}
                                            _hover={{ color: 'white' }}
                                            _active={{ color: 'white' }}
                                        />
                                        <InputRightAddon
                                            as={Button}
                                            color={'black'}
                                            colorScheme={'blue'}
                                            children={<FaSearch />}
                                            _hover={{ color: 'white' }}
                                            _active={{ color: 'white' }}
                                        />
                                    </InputGroup>
                                </Stack>
                            </Stack>
                            <Stack direction={{ md: 'column', lg: 'row' }}>
                                <InputGroup size='sm'>
                                    <Input
                                        w={'100%'}
                                        type={'date'}
                                        placeholder='Invoice Date'
                                        name="invoiceDate"
                                        value={formData.invoiceDate}
                                        onChange={handleInputChange}
                                    />
                                    <InputRightAddon
                                        as={Button}
                                        color={'black'}
                                        colorScheme={'blue'}
                                        children={"TD"}
                                        _hover={{ color: 'white' }}
                                        _active={{ color: 'white' }}
                                        onClick={handleTD}
                                    />
                                </InputGroup>
                                <Input
                                    w={'100%'}
                                    size={'sm'}
                                    type={'date'}
                                    placeholder='Due Date'
                                    name="dueDate"
                                    value={formData.dueDate}
                                    onChange={handleInputChange}
                                />
                            </Stack>

                            <Stack direction={{ md: 'column', lg: 'row' }}>
                                <InputGroup size='sm'>
                                    <Input
                                        w={'100%'}
                                        type={'text'}
                                        placeholder='Invoice Number'
                                        name="invoiceNumber"
                                        value={formData.invoiceNumber}
                                        onChange={handleInputChange}
                                    />
                                    <InputRightAddon
                                        as={Button}
                                        color={'black'}
                                        colorScheme={'blue'}
                                        children={'IN'}
                                        _hover={{ color: 'white' }}
                                        _active={{ color: 'white' }}
                                    />
                                </InputGroup>
                                <InputGroup size='sm'>
                                    <APIDropdown
                                        size={'sm'}
                                        placeholder="Select VAT/GST"
                                        valuekey={'id'}
                                        textkey={'name'}
                                        name="vatGstRateId"
                                        fetchurl={`/api/VATGST/${id}`}
                                        // selectedvalue={formData.vatGstRateId}
                                        value={formData.vatGstRateId}
                                        // defaultValue={formData.vatGstRateId}
                                        itemselect={vatGstRateChange}
                                        disabled={formData.vatMissing === true ? true : false}
                                    />
                                    <InputRightAddon
                                        as={Button}
                                        color={'black'}
                                        colorScheme={'blue'}
                                        children={'VM'}
                                        _hover={{ color: 'white' }}
                                        _active={{ color: 'white' }}
                                        onClick={VATMissing}
                                    />
                                    <InputRightAddon
                                        as={Button}
                                        color={'black'}
                                        colorScheme={'blue'}
                                        children={'VD'}
                                        _hover={{ color: 'white' }}
                                        _active={{ color: 'white' }}
                                    />
                                </InputGroup>
                            </Stack>

                            <Stack direction={{ md: 'column', lg: 'row' }}>
                                <APIDropdown
                                    size={'sm'}
                                    placeholder="Select Category"
                                    valuekey={'id'}
                                    textkey={'category'}
                                    fetchurl={`/api/ChartOfAccounts/${id}`}
                                    name="categoryId"
                                    value={formData.categoryId}
                                    itemselect={(value) => handleInputChange(value == null ? 0 : value.id, 'categoryId')}
                                />
                                <APIDropdown
                                    size={'sm'}
                                    placeholder="Payment Method"
                                    valuekey={'id'}
                                    textkey={'displayName'}
                                    fetchurl={`/api/PaymentMethods/${id}`}
                                    name="paymentMethodId"
                                    value={formData.paymentMethodId}
                                    itemselect={(value) => handleInputChange(value == null ? 0 : value.id, 'paymentMethodId')}
                                />
                            </Stack>

                            <Stack direction={{ md: 'column', lg: 'row' }}>
                                <InputGroup size='sm'>
                                    <Input
                                        w={'100%'}
                                        type={'number'}
                                        min={0}
                                        step="0.01"
                                        placeholder='Gross Amount'
                                        name="grossAmount"
                                        value={formData.grossAmount}
                                        onChange={(e) => {calculate(e.target.value, 'grossAmount')}}
                                        disabled={formData.transactionMissing === true ? true : false}
                                    />
                                    <InputRightAddon
                                        as={Button}
                                        color={'black'}
                                        colorScheme={'blue'}
                                        children={'TM'}
                                        _hover={{ color: 'white' }}
                                        _active={{ color: 'white' }}
                                        onClick={TransactionMissing}
                                    />
                                    <InputRightAddon
                                        as={Button}
                                        color={'black'}
                                        colorScheme={'blue'}
                                        children={'TO'}
                                        _hover={{ color: 'white' }}
                                        _active={{ color: 'white' }}
                                        onClick={TransactionZero}
                                    />
                                </InputGroup>

                                <Stack
                                    w={'full'}
                                    spacing={1}
                                    align={'center'}
                                    direction={'row'}
                                >
                                    <Input
                                        w={'full'}
                                        size={'sm'}
                                        type={'number'}
                                        min={0}
                                        step="0.01"
                                        placeholder={'VAT Amount'}
                                        name="vatAmount"
                                        value={formData.vatAmount}
                                        onChange={handleInputChange}
                                    />

                                    <Text w={'100%'} textAlign={'right'}>VAT %: <strong>{formData.vatGstRateValue}%</strong></Text>
                                </Stack>
                            </Stack>

                            <Stack direction={{ md: 'column', lg: 'row' }}>
                                <Input
                                    w={'full'}
                                    size={'sm'}
                                    type={'number'}
                                    min={0}
                                    step="0.01"
                                    placeholder={'Net Amount'}
                                    name="netAmount"
                                    onChange={handleInputChange}
                                    value={formData.netAmount}
                                    disabled
                                />
                                <APIDropdown
                                    size={'sm'}
                                    placeholder="Transaction Currency"
                                    name="transactionCurrencyId"
                                    itemselect={handleBaseCurrencyChange}
                                    valuekey={'id'}
                                    textkey={'currencyName'}
                                    fetchurl={`/api/Currency`}
                                    value={formData.transactionCurrencyId}
                                />
                            </Stack>

                            <Stack direction={{ md: 'column', lg: 'row' }}>
                                <Input
                                    w={'full'}
                                    size={'sm'}
                                    type={'text'}
                                    placeholder={'Base Currency'}
                                    value={formData.baseCurrency || companyInfo.baseCurrency || ''}
                                    name="baseCurrency"
                                    onChange={handleInputChange}
                                    disabled
                                />
                                <Input
                                    w={'full'}
                                    size={'sm'}
                                    type={'number'}
                                    min={0}
                                    step="0.01"
                                    placeholder={'Exchange Rate'}
                                    value={formData.exchangeRate}
                                    name="exchangeRate"
                                    onChange={(e) => {calculate(e.target.value,  'exchangeRate')}}
                                    textAlign={'end'}
                                />
                            </Stack>

                            <Stack direction={{ md: 'column', lg: 'row' }}>
                                <Input
                                    w={'full'}
                                    size={'sm'}
                                    type={'number'}
                                    min={0}
                                    step="0.01"
                                    placeholder={'Converted Gross Amount'}
                                    name="convertedGrossAmount"
                                    value={formData.convertedGrossAmount}
                                    disabled
                                />
                                <Input
                                    w={'full'}
                                    size={'sm'}
                                    type={'number'}
                                    min={0}
                                    step="0.01"
                                    placeholder={'Converted VAT Amount'}
                                    textAlign={'end'}
                                    name="convertedVATAmount"
                                    value={formData.convertedVATAmount}
                                    disabled
                                />
                                <Input
                                    w={'full'}
                                    size={'sm'}
                                    type={'number'}
                                    placeholder={'Converted Net Amount'}
                                    textAlign={'end'}
                                    name="convertedNetAmount"
                                    value={formData.convertedNetAmount}
                                    disabled
                                />
                            </Stack>

                            <Stack
                                w={'full'}
                                spacing={0.5}
                            >
                                <Stack
                                    w={'full'}
                                    spacing={1}
                                    direction={'row'}
                                    justify={'flex-end'}
                                >
                                    <Button
                                        _hover={{ bg: 'primary.400', color: 'white' }}
                                        _active={{ bg: 'primary.700', color: 'white' }}
                                        rounded={'none'}
                                        size={'sm'}
                                        w={'fit-content'}
                                        onClick={DescriptionMissing}
                                    >
                                        DM
                                    </Button>

                                    <Button
                                        _hover={{ bg: 'primary.400', color: 'white' }}
                                        _active={{ bg: 'primary.700', color: 'white' }}
                                        rounded={'none'}
                                        size={'sm'}
                                        w={'fit-content'}
                                    >
                                        MI
                                    </Button>
                                </Stack>
                                <Textarea
                                    resize={'none'}
                                    rounded={'none'}
                                    placeholder="Description"
                                    name="description"
                                    onChange={handleInputChange}
                                    value={formData.description}
                                    disabled={formData.descriptionMissing === true ? true : false}
                                ></Textarea>
                            </Stack>

                            <Stack direction={{ md: 'column', lg: 'row' }}>
                                <Select
                                    w={'full'}
                                    size={'sm'}
                                    name="additionalOptions"
                                    onChange={handleInputChange}
                                    value={formData.additionalOptions}
                                >
                                    <option value={'option1'}>Nothing Selected</option>
                                    <option value={'option2'}>Something Selected</option>
                                </Select>
                            </Stack>

                            <Stack
                                w={'full'}
                                direction={{ md: 'column', lg: 'row' }}
                            >
                                <Button
                                    w={'full'}
                                    size={'sm'}
                                    leftIcon={<FaSave />}
                                    color={'white'}
                                    bg={'primary.400'}
                                    _hover={{ bg: 'primary.400' }}
                                    _active={{ bg: 'primary.400' }}
                                    onClick={(value) => saveDocument("save")}
                                >
                                    Save
                                </Button>
                                <Button
                                    w={'full'}
                                    size={'sm'}
                                    leftIcon={<FaRandom />}
                                    color={'white'}
                                    bg={'primary.400'}
                                    _hover={{ bg: 'primary.400' }}
                                    _active={{ bg: 'primary.400' }}
                                    onClick={(value) => saveDocument("processed")}
                                >
                                    Process
                                </Button>
                                {
                                    role === "supervisor" &&
                                    <Stack
                                        w={'full'}
                                        spacing={1}
                                    >
                                        <Button
                                            w={'full'}
                                            size={'sm'}
                                            leftIcon={<FaTrash />}
                                            color={'red'}
                                            bg={'primary.400'}
                                            _hover={{ bg: 'primary.400' }}
                                            _active={{ bg: 'primary.400' }}
                                            onClick={handleDelete}
                                        >
                                            Delete
                                        </Button>
                                        <Button
                                            w={'full'}
                                            size={'sm'}
                                            leftIcon={<FaRedo />}
                                            color={'orange'}
                                            bg={'primary.400'}
                                            _hover={{ bg: 'primary.400' }}
                                            _active={{ bg: 'primary.400' }}
                                            onClick={handleRedo}
                                        >
                                            Redo
                                        </Button>
                                    </Stack>
                                }
                                
                            </Stack>
                        </Stack>
                    </Stack>
                </SimpleGrid>
            </Stack>
        </Stack >
    )
}